import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "Accueil", href: "#accueil", id: "accueil" },
  { label: "Projets", href: "#projets", id: "projets" },
  { label: "Services", href: "#services", id: "services" },
  { label: "À Propos", href: "#apropos", id: "apropos" },
  { label: "Contact", href: "#contact", id: "contact" },
];

export const scrollToSection = (href) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-40 bg-[#08080a]/80 backdrop-blur-xl border-b border-white/10"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <button
          onClick={() => scrollToSection("#accueil")}
          className="flex items-center gap-3 font-display font-extrabold text-xl tracking-tight"
          data-testid="nav-logo"
        >
          <img src="/logo-merdi.png" alt="Logo Merdi" className="w-9 h-9" />
          <img src="/logo-merdi-text.png" alt="Merdi" className="h-5 w-auto mt-1" />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.href)}
              className="text-sm text-zinc-400 hover:text-white transition-colors duration-300 font-mono uppercase tracking-[0.15em] text-xs"
              data-testid={`nav-link-${link.id}`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <span className="flex items-center gap-2 text-xs font-mono text-emerald-400" data-testid="nav-status">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
            Disponible
          </span>
          <button
            onClick={() => scrollToSection("#contact")}
            className="group flex items-center gap-1.5 bg-white text-black text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-blue-500 hover:text-white transition-colors duration-300"
            data-testid="nav-cta-button"
          >
            Me contacter
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:rotate-45" />
          </button>
        </div>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden border-t border-white/10 bg-[#08080a]/95"
            data-testid="nav-mobile-menu"
          >
            <div className="px-6 py-4 flex flex-col gap-4">
              {LINKS.map((link) => (
                <button
                  key={link.id}
                  onClick={() => {
                    scrollToSection(link.href);
                    setOpen(false);
                  }}
                  className="text-left text-zinc-300 hover:text-white font-display font-semibold text-lg"
                  data-testid={`nav-mobile-link-${link.id}`}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Nav;
